import { useWaitingExperience } from './useWaitingExperience';
import { VARIANT_REGISTRY } from './registry';

const WaitingExperience = () => {
	const { variant } = useWaitingExperience();
	const { Component: VariantContent } = VARIANT_REGISTRY[variant];

	return (
		<div className='z-10 mx-auto mt-4 mb-7 w-full max-w-[400px] md:mb-6'>
			<VariantContent />
		</div>
	);
};

export default WaitingExperience;
